import { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { Button, Card, Col, Form, Input, Row, Select } from 'antd';

import { qzTrayApiEndpoints } from '@/api/endpoints';

import { handleUpdatePostApi } from '@/api/crud';
import { useFetch } from '@/hooks';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import LoadingOverlay from '@/utils/loading/loadingOverlay';
import { rules } from '@/utils/validation/FormValidation';
import { AntRSelect } from '@/common/ant-components/AntRSelect';
import { useGetApiListNoToast, useMutateGetApi } from '@/apiError/apiShow';
import apiService from '@/apiError/apiServices';
import { useMutation } from '@tanstack/react-query';

const EditQzTraySetup = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const controller = new AbortController();

  // const { data } = useFetch(qzTrayApiEndpoints.retrieveList);
  const { data: CompanyData } = useGetApiListNoToast('/company/access/list/');

  const {
    mutate: getMutate,
    data: BranchData,
    isPending: branchLoading,
  } = useMutateGetApi();

  useEffect(() => {
    const signal = controller.signal;
    async function handleCompanyDetailsOnLoad() {
      try {
        const res = await qzTrayApiEndpoints.retrieve(id, signal);

        if (res.data.data) {
          const customer = res.data.data;
          getMutate({ url: `/companies/${res.data.data.companyId}/branches/` });

          if (customer) {
            form.setFieldsValue({
              ...customer,
            });
          }
        }
      } catch (error) {
        throw new Error(error);
      }
    }

    handleCompanyDetailsOnLoad();

    //  clear up function
    return () => {
      controller.abort();
    };
  }, [id]);

  const navigateToList = () => navigate('/transaction/qz-tray-setup/list/');

  return (
    <>
      <Card>
        <Form
          className="username"
          form={form}
          onFinish={(value) => {
            handleUpdatePostApi(
              id,
              qzTrayApiEndpoints.update,
              {
                ...value,
              },
              setLoading,
              form,
              navigateToList,
            );
          }}
          layout="vertical"
        >
          <LoadingOverlay spinning={loading} />
          <GlobalDivider name="Edit User" />
          <Row gutter={24}>
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <AntRSelect
                array={CompanyData?.data?.map((item) => ({
                  id: item.referenceId,
                  name: item.name,
                }))}
                onSelect={async (e) => {
                  if (e) {
                    getMutate({ url: `/companies/${e}/branches/` });
                  }
                }}
                renderKey={'name'}
                valueKey={'id'}
                placeholder="Select Company Name"
                formProps={{
                  name: 'companyId',
                  label: 'Company Name',
                  rules: [
                    {
                      required: true,
                      message: 'Please select any one company',
                    },
                  ],
                }}
              />
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <AntRSelect
                array={BranchData?.data?.map((item) => ({
                  id: item.referenceId,
                  name: item.branchName,
                }))}
                loading={branchLoading}
                renderKey={'name'}
                valueKey={'id'}
                placeholder="Select Branch Name"
                formProps={{
                  name: 'branchId',
                  label: 'Branch Name',
                  rules: [
                    {
                      required: true,
                      message: 'Please select any one branch',
                    },
                  ],
                }}
              />
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item label="Private Key" name="privateKey">
                <Input placeholder="Enter private key" />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item label="Digital Certificate" name="certificateKey">
                <Input placeholder="Enter digital certificate" />
              </Form.Item>
            </Col>
          </Row>

          <div className="flex justify-end">
            <div className="flex gap-2">
              <Button type="primary" htmlType="submit">
                Update
              </Button>
              <Button className="auto-danger-btn" onClick={() => navigate(-1)}>
                Back
              </Button>
            </div>
          </div>
        </Form>
      </Card>
    </>
  );
};

export default EditQzTraySetup;
